module.exports = __webpack_public_path__ + "img/m2.e741946790c92c3a0b4eca109182f261.png";